import { AbstractControl } from '@angular/forms';

export default function invalidDayForMonth(control: AbstractControl) {
  if (control && control.value) {
    const valueTokens = control.value.split('/');
    if (valueTokens.length > 1) {
      // Because JS dates are a month behind normal date inputs
      const month = mod(parseInt(valueTokens[0], 10) - 1, 12);
      const day = parseInt(valueTokens[1], 10);
      // If the user hasn't entered a year in the date value
      // we are optimistic and assume a leapyear
      let year = 2000;

      // Otherwise we will take their entered year into account
      if (valueTokens.length > 2 && valueTokens[2].length === 4) {
        year = valueTokens[2];
      }

      const testDate = new Date(year, month, day);

      // In JS if you make a date object with a date greater than
      // what exists in that month it will increment the month value
      if (testDate.getMonth() !== month) {
        return {
          invalidDayForMonth: true,
        };
      }
    }
  }
  return null;
}

// a mod n
function mod(a, n) {
  return ((a % n) + n) % n;
}
